import React, { useState, useEffect } from "react";
import "./styles.scss";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import UploadDocPopUp from "./uploadDocPopUp";
import {
  postSendMessageRequest,
  postAllMessageRequest,
} from "../../AdminModule/Dashboard/StartupDashboard/dependencies/action";
import moment from "moment";
import io from 'socket.io-client';
import { useHistory } from "react-router-dom";

function ChatBox(props) {
  const { postSendMessageRequest, postAllMessageRequest,getChatListData } = props;
  const [showSubmitAction, setShowSubmitAction] = useState(false);
  const [approvaloption, setApprovalOption] = useState("");
  const [action, setAction] = useState();
  const [submitData, setSubmitData] = useState();
  const [messageData, setMessageData] = useState("");
  const [fileData, setFileData] = useState("");
  const history = useHistory();

  const clickOnClose = () => {
    setShowSubmitAction((x) => !x);
    setShowSubmitAction(!showSubmitAction);
    setApprovalOption("Select");
  };
  const getChatData = () =>{
    let params = {
      senderId: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      receiverId: window?.receiverId,
    pageFilter: {
      currentPage: 0,
      includeCount: true,
      pageSize: 50,
      sortField: "createdDate",
      sortOrder: "DESC",
      id: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    },
  };
    // postAllMessageRequest(params);
    setTimeout(()=>{
      let div = document.getElementById('messageBody');
      div.lastElementChild.scrollIntoView({ behavior: 'smooth' });
    },500)

  }
  useEffect(()=>{
    getChatData();
  },[])
  useEffect(() => {
    const interval = setInterval(() => {
            getChatData();

    }, 10000);
    // setTimeout(()=>{
    //   getChatData();
    // },1000)
    return () => clearInterval(interval);
  },[]);
  useEffect(() => {
    
  }, [fileData]);
  const removeFile = (fileType) => {
    if (fileType === "uploadResume") {
      setFileData((user) => {
        return { ...user, ["uploadResume"]: null };
      });
    }
  };
  const handleSubmitMessage = () => {
    
    const formData = new FormData();
    if(messageData === ""){
      
    }
    if(fileData === ""){
      

    }
    if(messageData !== "" || fileData !== "")
    {
      
        let params = {
              senderId: JSON.parse(localStorage.getItem("SavedLoggedInData"))?.id,
              senderName: JSON.parse(localStorage.getItem("SavedLoggedInData"))?.name,
              receiverId: window?.receiverId,
              message: {
                commentByUserId: JSON.parse(localStorage.getItem("SavedLoggedInData"))
                  ?.id,
                commentedByUserRole: JSON.parse(
                  localStorage.getItem("SavedLoggedInData")
                )?.role,
                text: messageData,
              },
              taggingList: [window?.receiverId],
              allExpertTag: false,
              allStudentTag: false,
          };
          formData.append("message", JSON.stringify(params));
          formData.append("commentFile", fileData?.uploadResume);
          
          setMessageData("");
          setFileData("");
          postSendMessageRequest(formData);
          setTimeout(()=>{
            getChatData();
          },300)
    }
  };
  return (
    <>
      <div
        style={{ marginTop: "100px", position: "relative", top: "2rem",marginBottom: "20px" }}
        className="messageBox row"
      >
        <div className="messageTitle2">
          {
            
          }
          {window?.receiverInfo?.applicant_name}
          {/* {
            history?.location?.state?.applicant_name
          } */}
        </div>
        <div className="messageBody">
         {
          
         }
         {
          getChatListData && getChatListData?.length > 0 ? (
            getChatListData.map((chatItem, index) => (
              
              chatItem.message.commentByUserId == window?.receiverInfo?.id ? (
                <>
                <br/>
                 <div className="messageTimeshow">
              {moment(chatItem.message.createdDate).format("DD-MM-YYYY")}
              </div>
                <div className="senderMessageBox row">
                <div className="messageTextContent">
              {chatItem.message.text}
              <br/>
               {chatItem?.message?.filePath !== null && (
              <div
                className="file-name fileChatPositionFix"
                style={{ float: "left" }}
              >
                  <a href={chatItem.message.filePath} target="_blank" className="messageDocumentContent2">
                  Document
                          </a>
              </div>
          )}
          <div className="messageTime">
              {moment(chatItem.message.createdDate).format("hh:mm a")}
              </div>
              </div>
             
              </div>

              
              </>
              ) :
              (
                <>
                <br/>
                 <div className="messageTimeshow2">
                  <div className="d-flex justify-content-end" style={{width:"100%"}}>
              {moment(chatItem.message.createdDate).format("DD-MM-YYYY")}
              </div>
              </div>
                <div className="receiverMessageBox row">
                  <div className="d-flex justify-content-end messageTextContent2">
                {chatItem.message.text}
                </div>
                <div className="d-flex justify-content-end messageTextContent2">
               {chatItem?.message?.filePath !== null && (
              <div
                className="file-name sendDocumentPositionFix"
              >
                  <a href={chatItem.message.filePath} target="_blank" className="messageDocumentContent2">
                  Document
              </a>
              </div>
          )}
                </div>
                {/* <div className="d-flex justify-content-end messageTimeContent2">
                {moment(chatItem.message.createdDate).format("DD-MM-YYYY hh:mm A")}
                </div> */}
                  <div className="messageTime2">
              {moment(chatItem.message.createdDate).format("hh:mm a")}
              </div>
                </div>
                </>
                
              )
              ))
          ):
          <>
          <div className="emptyChatFix">No Messages here yet ...
            <br/>
            Send your first Message
          </div>
          </>
         }
        </div>
        <div className="messageFooter">
          <div class="input-group mt-3 mb-3">
            <input
              type="text"
              className="form-control sendMessagesText"
              placeholder="Send Message"
              aria-label="Recipient's username"
              aria-describedby="basic-addon2"
              style={{ fontFamily: "Montserrat" }}
              onChange={(e) => {
                setMessageData(e.target.value);
              }}
              value={messageData}
              onKeyDown={(e)=>{
                if (e.key === 'Enter') {
                  handleSubmitMessage();
                }
              }}
            />
            <div class="input-group-append d-flex">
              <span
                class="input-group-text sendDocBtn"
                onClick={() => setShowSubmitAction(true)}
                style={{ cursor: "pointer", marginLeft: "0.4rem" }}
              >
               
              </span>
              <span
                class="input-group-text sendMsgBtn"
                style={{ cursor: "pointer", marginLeft: "0.4rem" }}
                onClick={handleSubmitMessage}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-send"
                  viewBox="0 0 16 16"
                >
                  <path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576 6.636 10.07Zm6.787-8.201L1.591 6.602l4.339 2.76 7.494-7.493Z" />
                </svg>
              </span>
            </div>
          </div>
          {fileData && fileData?.uploadResume !== null && (
            <div className="">
              <div
                className="file-name fileChatPositionFix"
                style={{ float: "left" }}
              >
                {fileData?.uploadResume?.name}{" "}
                <span
                  style={{ marginLeft: "10px", cursor: "pointer" }}
                  onClick={() => removeFile("uploadResume")}
                >
                  {" "}
                  X{" "}
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
      {showSubmitAction ? (
        <UploadDocPopUp
          isOpen={showSubmitAction}
          className={"form-submit-modal"}
          onClose={clickOnClose}
          action={action}
          submitData={submitData}
          formName={"mentor-form"}
          setfileDataParent={setFileData}
        />
      ) : (
        ""
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    getChatListData: state.StartUpReducer.allIMMessages.data
  };
};

export default connect(mapStateToProps, {
  postSendMessageRequest,
  postAllMessageRequest,
})(withRouter(ChatBox));
